<template>
  <div class="container">
    <div id="layout">
      <div id="north">
        <header-info cur="4"></header-info>
      </div>
      <div id="center">
        <div
          id="content"
          class="content"
        >

          <div
            class="login"
            id="state_login"
          >
            <div class="login_title">绑定手机号</div>
            <form
              class="login_form"
              id="regForm"
            >
              <div class="login_item">
                <input
                  class="ipt"
                  type="text"
                  v-model="formInfo.mobile"
                  placeholder="手机号"
                  required=""
                  autocomplete="off"
                  maxlength="11"
                >
              </div>
              <div class="login_item item-verify">
                <input
                  v-model="verifyCode.code"
                  class="ipt verify"
                  type="text"
                  autocomplete="off"
                  placeholder="输入图形验证码"
                  required=""
                >
                <span
                  @click="getVerifyCode"
                  class="verify-code"
                  title="看不清，换一个"
                ><img :src="formatImage(verify.path)"></span>
              </div>
              <div class="login_item item-verify">
                <input
                  v-model="formInfo.mobile_code"
                  class="ipt verify"
                  type="text"
                  autocomplete="off"
                  placeholder="输入短信验证码"
                  required=""
                >
                <span
                  class="code"
                  @click="sendMsg"
                  :style="isMsgSend ? 'background:#ccc' : ''"
                >
                  {{ this.isMsgSend ? '' + this.seconds + '秒' : '获取验证码' }}
                </span>
              </div>

            </form>
            <div
              class="login_btn"
              id="loginBut"
              @click="login"
            >绑定</div>
          </div>
        </div>
      </div>
      <div id="south">
        <footer-info></footer-info>
      </div>
    </div>

  </div>
</template>

<script>
import HeaderInfo from '../../../components/HeaderInfo'
import FooterInfo from '../../../components/FooterInfo'
import { uuid } from 'vue-uuid'
export default {
  name: 'Login',
  components: {
    HeaderInfo,
    FooterInfo
  },
  data() {
    return {
      // 登录表单
      client_id: '',
      formInfo: {
        mobile: '',
        mobile_code: ''
      },
      verifyCode: {
        code: ''
      },
      verify: {
        path: '',
        code: '',
        show: false
      },
      step: 1,
      smsVerifyCode: '',
      isMsgSend: false,
      interval: null,
      seconds: 0,
      isRepeat: false
    }
  },
  methods: {
    async mobileRepeat() {
      await this.$http.get('/userprofile/', {
        params: {
          eq_mobile: this.formInfo.mobile
        }
      }).then((data) => {
        if (data.results.length) {
          this.isRepeat = true
        } else {
          this.isRepeat = false
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    async login() {
      var mobile = /^1[3456789]\d{9}$/ // 手机号

      if (!this.formInfo.mobile) {
        this.$layer.msg('手机号不能为空！')
        return
      } else if (!mobile.test(this.formInfo.mobile)) {
        this.$layer.msg('手机号格式有误！')
        return
      } else if (this.verify.show && !this.verifyCode.code) {
        this.$layer.msg('请输入图形验证码！')
        return
      } else if (!this.formInfo.mobile_code) {
        this.$layer.msg('请输入短信验证码！')
        return
      }
      await this.$http.post('/bind_phone/', {
        client_id: this.client_id,
        profile_id: this.$route.query.profile_id,
        mobile: this.formInfo.mobile,
        mobile_code: this.formInfo.mobile_code,
        code: this.verifyCode.code
      }).then((data) => {
        if (data.code === '200') {
          this.$layer.msg(data.msg)
          this.$router.push('/login')
        } else {
          this.$layer.msg(data.msg)
        }
      }).catch((error) => {
        this.$layer.msg('绑定失败！')
        console.dir(error)
      })
    },

    async getVerifyCode() {
      await this.$http.get('/login_code/', {
        params: {
          client_id: this.client_id
        }
      }).then(async (data) => {
        this.verify.path = data.path
        this.verify.show = true
      }).catch((error) => {
        console.log(error)
      })
    },

    formatImage (path) {
      return this.$store.state.rootUrl + path
    },
    async sendMsg() {
      var mobile = /^1[3456789]\d{9}$/ // 手机号
      await this.mobileRepeat()
      if (this.isMsgSend === true) {
        return
      } else if (!this.formInfo.mobile) {
        this.$layer.msg('手机号不能为空！')
        return
      } else if (!mobile.test(this.formInfo.mobile)) {
        this.$layer.msg('手机号格式有误！')
        return
      } else if (this.isRepeat) {
        this.$layer.msg('手机号已被绑定，请重新输入！')
        return
      }
      await this.$http.get('/send_mobile/', {
        params: {
          client_id: this.client_id,
          mobile: this.formInfo.mobile,
          template: 'SMS_238150787'
        }
      }).then((data) => {
        this.$layer.msg('验证码已发送，有效期两分钟！')
        this.smsVerifyCode = data.data
        this.isMsgSend = true
        this.seconds = 120
        this.interval = setInterval(() => {
          if (this.seconds === 0) {
            clearInterval(this.interval)
            this.isMsgSend = false
          }
          this.seconds -= 1
        }, 1000)
      }).catch(() => {
        this.$layer.msg('发送验证码失败！')
      })
    }
  },
  mounted() {
    this.client_id = uuid.v1()
    this.getVerifyCode()
  }
}
</script>

<style scoped>
@import "../../../assets/css/dialog.css";
@import "../../../assets/css/common.css";
@import "../../../assets/css/header.css";

@import "../../../assets/css/login.css";

.logo {
  background-image: url("../../../assets/images/logo.png");
}

#south {
  position: relative;
  width: 100%;
  bottom: 0px;
}

.container {
  height: 100%;
}

#layout {
  height: 98%;
  visibility: visible;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-content: center;
}
#app #center {
  padding-bottom: 0;
  background: #f5f5f5;
}
#app > div {
  height: 100vh;
  min-height: 100vh;
}
.code {
  background: #73D6CA;
  display: inline-block;
  float: right;
  width: 120px;
  height: 52px;
  color: #fff;
  line-height: 52px;
  text-align: center;
  cursor: pointer;
}
</style>
